import React from "react";
import { SecondaryButtonStyled, SimpleButtonStyled } from "../styles/Button";
import { TableStyled, TableHeaderStyled, TableDataStyled, TableRowStyled } from '../styles/Table';
import { PageHeader2Styled, PageHeaderSubTextMobileStyled } from "../styles/Main";
import { FormNavContainerStyled } from "../styles/Form";
import iconMap from "../data/iconMap";


const InputDescriptions = ({inputs, type, setShowInputDescriptions}) => {

    const capitalize = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    
    const displayDescriptions = () => {
        console.log(inputs);
        return Object.keys(inputs).map((item) => (
            <TableRowStyled key={item}>
                    <TableDataStyled $size={type==='capex'?20:45}>
                        {type==='general'?inputs[item].displayName:capitalize(item.replace('_', ' '))}
                    </TableDataStyled>
                    <TableDataStyled style={{textAlign: type==='capex'?'center':'inherit'}}>
                        {type==='general'?inputs[item].desc || "":inputs[item]}
                    </TableDataStyled>
            </TableRowStyled>
        ))
     }


    return (
        <div>
            <SimpleButtonStyled onClick={() => setShowInputDescriptions(0)}>{iconMap['Back']} Back</SimpleButtonStyled>
            <PageHeader2Styled>Input Descriptions</PageHeader2Styled>
            <PageHeaderSubTextMobileStyled>Descriptions for the following inputs</PageHeaderSubTextMobileStyled>
            <TableStyled>
                <thead>
                <TableRowStyled>
                    <TableHeaderStyled $size={type==='capex'?65:45}>Property Details</TableHeaderStyled>
                    <TableHeaderStyled style={{textAlign: type==='capex'?'center':'inherit'}} $size={55}>{type==='general'?'Description':'Typical Lifespan'}</TableHeaderStyled>
                </TableRowStyled>
                </thead>
                <tbody>
                {inputs && displayDescriptions()}
                </tbody>
            </TableStyled>
            <FormNavContainerStyled>
                <SecondaryButtonStyled onClick={() => setShowInputDescriptions(0)}>Back</SecondaryButtonStyled>
            </FormNavContainerStyled>
        </div>
    );
};


export default InputDescriptions;